import type { IRecentItem, IRecord } from '@platform/core/types';
import type { IRecordsTableItem } from './IRecordsTableItem';

/** Ім'я виконавця запису (поле assignee — посилання на користувача) або null. */
export function assigneeName(record: IRecord | undefined): string | null {
  const a = record?.values['assignee'];
  return a && typeof a === 'object' && !Array.isArray(a) ? a.name : null;
}

/** Рядки «Нещодавніх» (прототип v4): `limit` записів робочого простору, оновлених останніми, найновіші першими. Чиста функція. */
export function recentlyUpdated(records: readonly IRecord[], ws: string, limit = 30): IRecordsTableItem[] {
  return [...records].sort((a, b) => Date.parse(b.updatedAt) - Date.parse(a.updatedAt)).slice(0, limit).map((r) => ({
    recordId: r.id, recordType: r.recordType, module: r.module, workspaceId: ws, display: r.display, title: r.title, status: r.status,
    assignee: assigneeName(r), at: r.updatedAt,
  }));
}

/** Рядки «Обраного»: записи з /me/favourites, виконавець — із завантажених записів робочого простору (якщо запис серед них). Чиста функція. */
export function favouriteItems(items: readonly IRecentItem[], records: readonly IRecord[]): IRecordsTableItem[] {
  const byId = new Map(records.map((r) => [r.id, r]));
  return items.map((i) => ({ ...i, assignee: assigneeName(byId.get(i.recordId)) }));
}
